import { useMemo } from 'react';

import useOrganization from '~/components/OrganizationContext';
import { isClaimFlagsOperational } from '~/Utils';

import type {
  ClaimFlagConfiguration,
  ClaimFlagConfigurationsResponse,
  UseFetchClaimFlagConfigurationsReturnType,
} from '../types';

interface UseClaimFlagConfigurationsReturnType extends UseFetchClaimFlagConfigurationsReturnType {
  /** At least one enabled flag is configured for the org */
  isOperational: boolean;
}

interface PartialUseOrganizationContext {
  claimFlagConfigurations: ClaimFlagConfiguration[];
  isLoadingClaimFlagConfigurations: boolean;
  reloadClaimFlagConfigurations: () => Promise<ClaimFlagConfigurationsResponse | undefined>;
  isErrorClaimFlagConfigurations: boolean;
}

const useClaimFlagConfigurations = (): UseClaimFlagConfigurationsReturnType => {
  const {
    claimFlagConfigurations,
    isLoadingClaimFlagConfigurations: isLoading,
    reloadClaimFlagConfigurations: reloadData,
    isErrorClaimFlagConfigurations: isError,
  } = useOrganization() as PartialUseOrganizationContext;

  const isOperational = useMemo(() => isClaimFlagsOperational(claimFlagConfigurations), [claimFlagConfigurations]);

  return {
    claimFlagConfigurations: claimFlagConfigurations || [],
    isOperational,
    isLoading,
    isError,
    reloadData,
  };
};

export default useClaimFlagConfigurations;
